export default {"src":"/_next/static/media/KREF.73293bcd.svg","height":18,"width":18};